module.exports = __webpack_public_path__ + "static/media/roboto5.020c97dc.woff2";